import styled from 'styled-components';
const CrewCTAContainer = styled.div`
  position: relative;

  #left,
  #right {
    position: absolute;
    width: 4em;
    height: 4em;
  }
  #left {
    right: 85%;
    top: 45%;
    transform: rotateY(180deg) scale(0.8);
  }
  #right {
    left: 84%;
    top: 40%;
  }
`;

export default CrewCTAContainer;
